module.exports = __webpack_public_path__ + "04_very_short_brown.647cc205.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_very_short_brown.png
// module id = /dGw
// module chunks = 0